module.exports = "<button type=\"button\" class=\"{{btnClass}}\" (click)=\"openDialog()\">\r\n    <span *ngIf=\"type == 'image'\">\r\n        <i class=\"fa fa-image mr-4\"></i> {{btnTitle}}\r\n    </span>\r\n    <span *ngIf=\"type != 'image'\">\r\n        <i class=\"fa fa-file-o mr-4\"></i> {{btnTitle}}\r\n    </span>\r\n</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/upload/upload.component.html
// module id = ./src/app/modules/shared/upload/upload.component.html
// module chunks = main